import React from 'react'


const PortfolioSeriousProject = () => {
  return (
    <h1>portfolio serious view</h1>
  )
}

export default PortfolioSeriousProject